export const WINDOW_MARGIN = 20;
export const BLOCK_TASKDETAIL_GAP = 5;
